import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
// import KRGlue from "@lyracom/embedded-form-glue";
const baseUrlReniec = environment.apiUrl;
@Injectable({
  providedIn: "root",
})
export class EcommService {
  constructor(private http: HttpClient) {}
  tkn: any = [];
  getParam(baseUrl:string,urlApi, param: any): Observable<any> {
    let ultimocaracter = urlApi.substr(urlApi.length - 1);
    let paramUrl: any = "";
    if (ultimocaracter == "/") {
      param.forEach((el) => {
        paramUrl += el.valor + "/";
      });
    } else {
      paramUrl = "?";
      param.forEach((el) => {
        if (typeof el.valor != undefined) {
          if (el.valor != null) {
            if (el.valor.length != 0)
              paramUrl += el.clave + "=" + el.valor + "&";
          }
        }
      });
    }

    baseUrl + paramUrl;

    // //console.log(baseUrl + urlApi + paramUrl)
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.http.get(baseUrl + urlApi + paramUrl, { headers: headers });
  }
  getParamTkn(baseUrl:string,urlApi, param: any): Observable<any> {
    this.tkn = JSON.parse(sessionStorage.getItem("tk"));
    let ultimocaracter = urlApi.substr(urlApi.length - 1);
    let paramUrl: any = "";
    if (ultimocaracter == "/") {
      param.forEach((el) => {
        paramUrl += el.valor + "/";
      });
    } else {
      paramUrl = "?";
      param.forEach((el) => {
        if (typeof el.valor != undefined) {
          if (el.valor != null) {
            if (el.valor.length != 0)
              paramUrl += el.clave + "=" + el.valor + "&";
          }
        }
      });
    }

    // baseUrl + paramUrl;

    // //console.log(baseUrl + urlApi + paramUrl)
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.tkn.Token,
    });
    return this.http.get(baseUrl + urlApi + paramUrl, { headers: headers });
  }
  create(baseUrl:string,urlApi, param: any): Observable<any> {
    this.tkn = JSON.parse(sessionStorage.getItem("tk"));
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.tkn.Token,
    });
    return this.http.post(baseUrl + urlApi, param, { headers: headers });
  }
  post(urlApi): Observable<any> {
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "accept-encoding": "identity",
      "user-agent": "Lyra-Network Agent",
      "content-length": "8727",
    });
    return this.http.post(urlApi, { headers: headers });
  }
  createSinTk(baseUrl:string,urlApi, param: any): Observable<any> {
    this.tkn = JSON.parse(sessionStorage.getItem("tk"));
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.http.post(baseUrl + urlApi, param, { headers: headers });
  }
  update(baseUrl:string,urlApi, param: any): Observable<any> {
    this.tkn = JSON.parse(sessionStorage.getItem("tk"));
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.tkn.Token,
    });
    //console.log(this.tkn.Token);
    return this.http.put(baseUrl + urlApi, param, { headers: headers });
  }
  updatewhitoken(baseUrl:string,urlApi, param: any, tkn): Observable<any> {
    this.tkn = JSON.parse(sessionStorage.getItem("tk"));
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + tkn,
    });
    return this.http.put(baseUrl + urlApi, param, { headers: headers });
  }
  getAll(baseUrl:string,urlApi): Observable<any> {
    let tkns = JSON.parse(sessionStorage.getItem("tk"));
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + tkns.Token,
    });
    return this.http.get(baseUrl + urlApi, { headers: headers });
  }
  getById(baseUrl:string,urlApi, id): Observable<any> {
    let tkns = JSON.parse(sessionStorage.getItem("tk"));
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + tkns.Token,
    });
    return this.http.get(baseUrl + urlApi + id, { headers: headers });
  }
  getInfoQuery(baseUrl:string,urlApi, param) {
    let paramUrl = "?" + param.clave + "=" + param.valor;
    return this.http.get(baseUrl + urlApi + paramUrl, {
      observe: "response",
    });
  }
  updateId(baseUrl:string,urlApi, id): Observable<any> {
    return this.http.put(baseUrl + urlApi + id, {
      observe: "response",
    });
  }
}
